/* eslint-disable */

/** unique or primary key constraints on table "argo.sn_format" */
export enum ArgoSnFormatConstraint {
  /** unique or primary key constraint on columns "context_id", "sn_format_id" */
  SnFormatPkey = 'sn_format_pkey',
  /** unique or primary key constraint on columns "context_id", "name_unique" */
  SnFormatUniqueName = 'sn_format_unique_name',
  /** unique or primary key constraint on columns "context_id", "sn_format_id", "unq" */
  SnFormatUniqueUnq = 'sn_format_unique_unq'
}

/** select columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeqGrouping = 'seq_grouping',
  /** column name */
  Status = 'status',
  /** column name */
  Unq = 'unq',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_sn_format_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** select "argo_sn_format_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.sn_format" */
export enum ArgoSnFormatSelectColumnArgoSnFormatAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "argo.sn_format" */
export enum ArgoSnFormatUpdateColumn {
  /** column name */
  Config = 'config',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Revision = 'revision',
  /** column name */
  SeqGrouping = 'seq_grouping',
  /** column name */
  Status = 'status',
  /** column name */
  Unq = 'unq',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

